export default __webpack_public_path__ + "static/media/login-bg.a6519aa2.png";